import { APP_BASE_HREF } from '@angular/common';
import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Inject,
  Input,
  OnInit,
  Output,
  QueryList,
  ViewChild,
  ViewChildren,
  ViewEncapsulation,
} from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AppService } from '@app/_core/services/app.service';
import { FormDataService } from '@app/_core/services/form-data.service';
import { ManagerService } from '@app/_core/services/manager.service';
import { QueuesService } from '@app/_core/services/queues.service';
import { WebStorageService } from '@app/_core/services/webstorage.service';
import { ConfirmDialogComponent } from '@app/pages/common/confirm-dialog/confirm-dialog.component';
import { OutboundComponent } from '@app/pages/queue/outbound/outbound.component';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { ChildComponent } from '../../case-detail.component';
import { Utils } from '@app/_core/helper/Utils';
import{NotesHelper} from '@app/_core/helper/NotesHelper';
@Component({
  selector: 'app-create-case',
  templateUrl: './create-case.component.html',
  styleUrl: './create-case.component.scss',
  encapsulation: ViewEncapsulation.None,
})
export class CreateCaseComponent implements OnInit, ChildComponent {
  @Input()
  Heading: any;
  @Input()
  reason: any;

  isCreateNewCase: true;
  showCreateCase: boolean;
  showSearch: boolean;
  @ViewChild('input') input;
  @Input() conf: any;
  @Input() caseDetailsConf: any;
  @Input() ReadOnly: boolean;
  @Input() tabName: any;
  @Input() selectedData: any;
  @Output() formDataEmitter = new EventEmitter<any>();
  @Output() formDataHasError = new EventEmitter<any>();
  formData: any = {};
  statusValue: any;
  priorityValue: any;
  searchValue: any = '';
  cases: any[] = [];
  caseDetails: any;
  caseDetailsToShow: any;
  caseData: any = {};
  caseDataPerPage = [];
  first1: number = 0;
  rows1: number = 10;
  currentPage = 1;
  totalRecords: number;
  count = 0;
  emptyCaseRes: any;
  modalRef?: BsModalRef;
  isEdit: boolean;
  show: boolean = true;
  activityId: any;
  userId: any;
  queueID: any;
  caleeId: any;
  user: any;
  company: any;
  selectedCaseId: any;
  caseDataRes: any;
  toDate: Date = new Date();
  searchedUserData: any;
  editedCases: any = [];
  FindMemberValue: any;
  isSelected: boolean = false;
  casePriority: any;
  selectedFindMember: any;
  selectedUserData: any;
  display: string = 'none';
  errorSummary: any = [];
  changeData: any = [];
  groups: any;
  fullName: any;
  clientAbbreviation: any;
  selectedUserID: any;
  @ViewChildren('child') children: QueryList<ChildComponent>;
  formDataValid: boolean = true;
  constructor(
    private fb: FormBuilder,
    private queueService: QueuesService,
    private managerService: ManagerService,
    private route: ActivatedRoute,
    private router: Router,
    private modalService: BsModalService,
    public bsModalRef: BsModalRef,
    private webStorageService: WebStorageService,
    @Inject(APP_BASE_HREF) public baseHref: string,
    private formDataService: FormDataService,
    private appService: AppService,
    private queueServices: QueuesService,
    private cdref: ChangeDetectorRef,
    private outboundComponent: OutboundComponent,
    private utils: Utils,
    private notesHelper:NotesHelper
  ) {}

  ngOnInit(): void {
    this.clientAbbreviation = Utils.fetch('clientAbbreviation');
    //console.log(this.reason);
    //console.log(this.Heading);
    this.handleSelectedUser(null);
    this.isCreateNewCase = true;

   // console.log(this.selectedUserID);

    this.showSearch = true;
    this.user = this.webStorageService.getItemFromSessionStorage('currentUser');
    this.company = this.webStorageService.getItemFromSessionStorage('company');
    this.appService.activityId.subscribe(value => {
      this.activityId = value;
    });
    this.selectedCaseId = 0;
    this.appService.selectedQueueId.subscribe(queueId => {
      this.queueID = queueId;
    });
  }

  handleSelectedUser(event) {
    //console.log(event);

    if (event != null && this.reason == 'create-case') {
      this.showCreateCase = true;
      this.selectedUserID = event[0].UserID;
      this.selectedCaseId = null;
      this.showSearch = false;
      this.Heading = 'Create a New Case';
      this.fullName = event[0].FullName;
    } else if (this.reason == 'create-case' && event == null) {
      this.showCreateCase = false;
      this.showSearch = true;
      this.Heading = 'Select a User';
    }
  }

  changeUser() {
    this.showCreateCase = false;
    this.showSearch = true;
    this.Heading = 'Select a User';
  }

  closeCaseCreation() {
    this.bsModalRef.hide();
  }

  getFormData() {
    let formData = this.formData;
    console.log('formData', formData);
  }
  initializeFormData() {
    // Create formData model object from conf fields
    this.conf.Groups.forEach(group => {
      let groupName = group.GroupName.replaceAll(' ', '');
      if (group.IsMultiple) {
        let groupedData = [];
        //Existing field in group
        group.Fields.forEach((field, i) => {
          let obj: any = {};
          obj.id = field.fieldID;
          obj.name = field.Name;
          obj.value = field.value;
          groupedData.push(obj);
        });

        //Create and push new field in conf Fields for each multipleOptions.optionValues
        group?.multipleOptions?.optionValues?.forEach(option => {
          option.items.forEach(item => {
            let obj: any = {};
            obj.id = item.id;
            obj.name = item.name;
            obj.value = item.value;
            groupedData.push(obj);

            let newField = {
              fieldID: null,
              Name: '',
              Label: '',
              fieldType: 'Input',
              value: '',
              fileAttribute: null,
              isAlphaNumeric: false,
              isEmail: false,
              isMobile: false,
              isRegex: false,
              isRequired: false,
              maxLength: null,
              minLength: null,
              pattern: '',
              dateAttribute: null,
              fieldOptions: [],
            };

            newField.fieldID = item.id;
            newField.Name = item.name;
            newField.Label = item.name;
            newField.value = item.value;
            newField.isRequired = true;
            group.Fields.push(newField);
          });
        });
        this.formData[group.GroupName] = groupedData;
      } else {
        group.Fields.forEach(field => {
          // if (field.Name == 'Notes') {
          //   if (field.value) {
          //     field.value = '';
          //   }
          // }
          if (field.fieldType == 'FilePicker') {
            if (field.value) {
              field.value = JSON.parse(field.value);
            }
          }
          this.formData[field.Name] = field.value;
          if (field.dataSource && field.fieldOptions.length == 0) {
            this.getData(field);
          }
          if (field.childDataSource && field.fieldOptions.length == 0) {
            this.getChildData(field);
          }
          if (field.childSourceFromAdmin && field.fieldOptions.length == 0) {
            this.getChildDataFromConfiguration(field);
          }
        });
      }
    });
    // show/hide the dependent fields
    this.showAllDependentFields();
    console.log('formData', this.formData);
  }
  getData(fieldObj) {
    this.formDataService.getData(fieldObj.dataSource).subscribe(response => {
      //console.log("getData response", response.Response.Data);
      fieldObj.fieldOptions = response.Response.Data;
    });
  }

  getChildData(fieldObj) {
    let childFieldID = fieldObj.children.childFields[0].fieldID;
    let childField: any = this.getFieldByID(childFieldID);
    childField.fieldOptions = [];
    if (fieldObj.value) {
      this.formDataService.getData(fieldObj.childDataSource + fieldObj.value).subscribe(response => {
       // console.log('getData response', response.Response.Data);
        childField.fieldOptions = response.Response.Data;
      });
    }
  }
  getFieldByID(fieldID) {
    let targetField = {};
    this.conf.Groups.forEach(group => {
      group.Fields.forEach(field => {
        if (fieldID == field.fieldID) {
          targetField = field;
        }
      });
    });
    return targetField;
  }

  getSelectedOption(field, value) {
    let targetOption: any = {};
    field.fieldOptions.forEach(option => {
      if (option.Value == value) {
        targetOption = option;
      }
    });
    return targetOption;
  }
  showAllDependentFields() {
    this.conf.Groups.forEach(group => {
      group.Fields.forEach(field => {
        field.show = true;
        if (field.parent && field?.parentFieldOption) {
          // Is dependent
          field.show = false;
          field.parent.parentFields.forEach(item => {
            let parentField: any = this.getFieldByID(item.fieldID);
            let selectedOption = this.getSelectedOption(parentField, parentField.value);
            //To which option the field is dependent?
            let depends = false;
            field?.parentFieldOption?.parentFieldOption.forEach(item => {
              if (item.fieldOptionID == selectedOption.FieldOptionID) {
                depends = true;
                console.log(field.Name + ' is dependent on ' + parentField.Name + ' : ' + parentField.value);
              }
            });
            if (depends) {
              field.show = true;
            }
          });
        }
      });
    });
  }

  emitFormData() {
    this.formDataService.updateFormData(this.conf.TabValue, this.formData);
    console.log('Updated ', this.conf.TabValue, this.formData);
    this.formDataEmitter.emit(this.formData);
    //console.log("JSON.stringify(this.conf)", JSON.stringify(this.conf));
    // let cachedData = JSON.parse(sessionStorage.getItem(this.conf.TabValue + '_conf')) || [];
    // let index = cachedData.findIndex(item => item.caseId === this.formData.CaseID);
    // if (index !== -1) {
    //   cachedData[index] = { conf: this.conf, caseId: this.formData.CaseID };
    // } else {
    //   if (this.formData.CaseID) {
    //     cachedData.push({ conf: this.conf, caseId: this.formData.CaseID });
    //   }
    // }
    // sessionStorage.setItem(this.conf.TabValue + '_conf', JSON.stringify(cachedData));
  }
  getAllDynamicFormData() {
    // if (this.children && this.children.length > 0) {
    this.children?.forEach((child, index) => {
      child.emitFormData();
    });
    let formData: any = this.formDataService.getFormData();
    // let disposition = this.appService.getDispositionPayload();
    // formData.disposition = disposition;
    console.log('All Tabs Data:', formData);
    this.caseData = formData.cases;
    // }
  }

  onChildFormData(childData: any, selectedTab: string) {
    //console.log('onChildFormData:', selectedTab, childData);
  }

  handleFormDataHasError(hasError, selectedTab) {
    // Disable submit button if hasError

    if (hasError) {
      this.formDataValid = true;
    } else {
      this.formDataValid = false;
    }

    //console.log(selectedTab + ' form has error', hasError);
  }

  confirm() {
    this.getAllDynamicFormData();

   // console.log(this.caseData);
    // **Remove CasePriorityID if its value is an empty --ONV-5547
    if (this.caseData.CasePriorityID === '') {
      delete this.caseData.CasePriorityID;
    }
    // this.formData.FindMember = this.FindMemberValue;
    let findMemberId = this.appService.getLookUpMemberId();
    if (findMemberId?.length > 0) {
      const fieldAttr = Object.keys(this.caseData);
      fieldAttr?.forEach(field => {
        let index = findMemberId.findIndex(
          fmItem => fmItem.caseId == this.caseData.CaseID && fmItem.fieldName == field
        );
        if (index !== -1) {
          this.caseData[field] = findMemberId[index].findMemberId;
        }
      });
    }
    // console.log(findMemberId);
    // if(findMemberId && findMemberId.length>0)
    // {
    //   if(this.caseData.hasOwnProperty("FindMember"))
    //     this.caseData.FindMember = findMemberId[0].findMemberId ? findMemberId[0].findMemberId : '' ;
    //   if(this.caseData.hasOwnProperty("MemberPicker"))
    //     this.caseData.MemberPicker=findMemberId[0].findMemberId ? findMemberId[0].findMemberId : '' ;
    //  }
    if (this.caseData && !this.notesHelper.isEmptyOrWhitespace(this.caseData.Notes)) {
      this.caseData.Notes= this.generateNotesContent(this.caseData.Notes,null,null); 
    }

   // console.log(findMemberId);
    delete this.caseData['CaseID'];
   // console.log(this.caseData);
    const data = {
      addUserAsPrimary: false,
      activityId: this.activityId,
      queueId: this.queueID,
      userID: this.selectedUserID,
      company: this.company,
      user: this.user,
      caseData: this.caseData,
    };
    this.managerService.createCase(data).subscribe(res => {
      //console.log(res);

      if (res) {
        const initialState = {
          contentMsg: 'New case has been created for ' + this.fullName,
          confirmBtnValue: 'Ok',
          cancelBtnValue: '',
          isConfirm: true,
          isDelete: false,
        };

        const config: ModalOptions = {
          backdrop: 'static',
          class: 'confirm-dialog modal-wd-290',
          initialState,
        };
        this.appService.clearLookupMemberId();
        this.modalRef = this.modalService.show(ConfirmDialogComponent, config);
        this.modalRef.content.event.subscribe(() => {
          // if (result.value == 'confirm') {
          //   console.log('create')
          //   // this.router.navigate([this.clientAbbreviation + '/Queue/caseDetails']);
          // } else {
          //   this.bsModalRef.hide();
          // }
          this.modalRef.hide();
        });
        this.bsModalRef.hide();
      }
      // this.caseData.length = 0;

      console.log(this.caseData);
    });
  }
  cancel() {
    this.bsModalRef.hide();
  }
  getChildDataFromConfiguration(fieldObj) {
    let childFieldID = fieldObj.children.childFields[0].fieldID;
    let childField: any = this.getFieldByID(childFieldID);
    childField.fieldOptions = [];
    if (fieldObj.value) {
      let payload = {
        queueID: this.queueService.getselectedQueueId(),
        activityID: this.activityId,
        fieldID: fieldObj.fieldID,
        fieldName: fieldObj.Name,
        parentValue: fieldObj.value,
        type:"TMCaseDetail"
      };
      this.queueService.getDependantDataSource(payload).subscribe(response => {
        childField.fieldOptions = response.Response.Data;
      });
    }
  }
   
  generateNotesContent(_notes: string, oldNotes: string, user: any): string {
    if (!this.notesHelper.isEmptyOrWhitespace(_notes)) {
      return this.notesHelper.encodeUnicodeText(_notes);
    }
    return '';
  }
  confirmOpen = false;
  handleSelectedUserNotFound(event) {
    if (event != null) {
      console.log('add-rec-cont');
      const initialState = {
        contentMsg: 'This will create a new user record. Are you sure you would like to continue?',
        confirmBtnValue: 'Ok',
        cancelBtnValue: 'Cancel',
        isConfirm: true,
        isDelete: false,
      };

      const config: ModalOptions = {
        backdrop: 'static',
        class: 'confirm-dialog modal-wd-290',
        initialState,
      };

      this.modalRef = this.modalService.show(ConfirmDialogComponent, config);
      this.modalRef.content.event.subscribe((result: any) => {
        if (result.value == 'confirm') {
          console.log('create');
          this.bsModalRef.hide();
         // const actionItem = this.getActionItem();
            const actionItem = this.queueServices.getselectedQueueId() + "-new_";
          this.appService.setActionItemId(actionItem);
          this.appService.setIsAddNewUser(true);
          //this.appService.setConfirmationStatus(true);
          this.router.navigate([this.clientAbbreviation + '/Queue/caseDetails']);
        } else {
          this.bsModalRef.hide();
        }
        this.modalRef.hide();
      });
    }
  } 
}
